import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SvgComponent } from '@terminus-ui/svg';
import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { ProductService } from '../services/product.service';

const centralLogo = require('../../assets/images/central-logo-icon.png');
const centralLogoSvg = require('../../assets/images/central-logo-icon-only.svg');
@Component({
  selector: 'lib-home-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
  imports: [
    CommonModule,
    CardModule,
    FontAwesomeModule,
    RouterModule,
    TagModule,
    SvgComponent,
  ],
})
export class ProductListComponent {
  productService = inject(ProductService);
  public centralLogo = centralLogo;
  public centralLogoSvg = centralLogoSvg;
}
